// Selectable output framerates. Must stay in sync with the server's closed
// set (PHOTO_COMPILE_ALLOWED_FPS in functions/timelapse/api/main.py); the
// callable re-validates, so this list is UX-only, not a trust boundary.
//
// Lives in its own module (not PhotoCompileCta.js) so consumers that only
// need the numbers — like the GoPro door page's copy — don't have to pull in
// PhotoCompileCta's module graph (firebase/functions and friends).
export const FPS_OPTIONS = [24, 30, 60];
export const DEFAULT_FPS = 24;
